import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiPath from '../../utils/apiPath';

  /* fetch block */
  export const fetchBlocks = createAsyncThunk(
    "blocks",
    async (clientId,  rejectWithValue ) => {
      try {
        const response = await apiPath.get(`/api/v1.0/blocks?client_id=${clientId}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  /* create block */
  export const createBlock = createAsyncThunk('block/create',async (blockData, { rejectWithValue }) => {
    try {
      const response = await apiPath.post(`/api/v1.0/blocks/create`, blockData);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  });

  /* update block */
  export const updateBlock = createAsyncThunk(
    "block/update",
    async ({ id, blockData },  rejectWithValue ) => {
      try {
        const response = await apiPath.put(`/api/v1.0/blocks/${id}`, blockData);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  /* block detail */
  export const blockDetail = createAsyncThunk(
    "block/detail",
    async (id, { rejectWithValue }) => {
      try {
        const response = await apiPath.get(`/api/v1.0/blocks/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  /* delete block */
  export const deleteBlock = createAsyncThunk(
    "block/delete",
    async (id, { rejectWithValue }) => {
      try {
        await apiPath.delete(`/api/v1.0/blocks/${id}`);
        return id;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  /* fetch block Lists */
  export const blockLists = createAsyncThunk(
    "block/list",
    async (clientId, { rejectWithValue }) => {
      try {
        const response = await apiPath.get(`/api/v1.0/blocks/lists?client_id=${clientId}&status=active`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  /* patch API */
  export const updateSingleBlockData = createAsyncThunk(
    "single-block/update",
    async ({id,blockData}, { rejectWithValue }) => {
      try {
        const response = await apiPath.patch(`/api/v1.0/blocks/${id}`,blockData);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  /* save orrdering */
  export const saveBlockOrdering = createAsyncThunk('block/ordering',async (blockOrderingData, { rejectWithValue }) => {
    try {
      const response = await apiPath.post(`/api/v1.0/blocks/ordering`, blockOrderingData);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  });

/* Block Slice @start */
const blockSlice = createSlice({
  name: 'block',
  initialState: {
    blocks: [],
    blockLists: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* Fetch Blocks */
      .addCase(fetchBlocks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlocks.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.blocks = [];
        state.blocks = action.payload.blocks;
      })
      .addCase(fetchBlocks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Create Block */
        .addCase(createBlock.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBlock.fulfilled, (state, action) => {
        const data = {...action.payload,attributes:0}
        state.blocks.push(data); 
        if (data.show_in_sidebar === "true") {
          state.blockLists.push(data);
        }
        state.loading = false;
        state.error = null;
      })

      .addCase(createBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
    
      /* Update Block */
      .addCase(updateBlock.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const index = state.blocks.findIndex((b) => b.id === action.payload.id);
        if (index !== -1) state.blocks[index] = {...state.blocks[index], ...action.payload};
        if (index !== -1) state.blockLists[index] = {
            ...state.blockLists[index],
            ...action.payload
          }

        // const blocksIndex = state.blocks.findIndex(
        //   (block) => block.id === action.payload.id
        // );
        // if (blocksIndex !== -1) {
        //   state.blocks[blocksIndex] = {...state.blocks[blocksIndex], ...action.payload};
        // }
        
        // /* Update in blockLists.blocks array */
        // const blockListsIndex = state.blockLists.blocks?.findIndex(
        //   (block) => block.id === action.payload.id
        // );
        // if (blockListsIndex !== -1) {
        //   state.blockLists.blocks[blockListsIndex] = {
        //     ...state.blockLists.blocks[blockListsIndex],
        //     ...action.payload
        //   };
        // }
      })
      .addCase(updateBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
    
      /* Delete Block */
      .addCase(deleteBlock.fulfilled, (state, action) => {
        state.blocks = state.blocks.filter(
          (block) => block.id !== action.payload
        );
      })
      .addCase(deleteBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message;
      })

      /* Block Details */
      .addCase(blockDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(blockDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.blockDetail = action.payload.details;
      })
      .addCase(blockDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Block Lists */
      .addCase(blockLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(blockLists.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.blockLists = action.payload.blocks;
      })
      .addCase(blockLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* Update Single Field */
      .addCase(updateSingleBlockData.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        
        /* Update in blocks array */
        const blocksIndex = state.blocks.findIndex(
          (block) => block.id === action.payload.id
        );
        if (blocksIndex !== -1) {
          state.blocks[blocksIndex] = {...state.blocks[blocksIndex], ...action.payload};
        }
        
        /* Update in blockLists.blocks array */
        const blockListsIndex = state.blockLists?.findIndex(
          (block) => block.id === action.payload.id
        );
        if (blockListsIndex !== -1) {
          state.blockLists[blockListsIndex] = {
            ...state.blockLists[blockListsIndex],
            ...action.payload
          };
        }
      })

      /* Block Ordering */
      .addCase(saveBlockOrdering.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveBlockOrdering.fulfilled, (state,action) => {
        state.loading = false;
        state.error = null;
        state.blocks = action.payload.blocks
        state.blockLists = action.payload.blocks
      })
      .addCase(saveBlockOrdering.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default blockSlice.reducer;
